import { SubscriberTypeEnum } from 'generated/graphql';

/**
 * The "I am a" options, in the order the modal offers them.
 *
 * The enum comes from the schema, so the values cannot drift from the backend —
 * only the labels live here. They match the option labels configured on the
 * HubSpot `subscriber_type` property, which is what marketing segments on.
 */
export const SUBSCRIBER_TYPE_OPTIONS: ReadonlyArray<{
    value: SubscriberTypeEnum;
    label: string;
}> = [
    {
        value: SubscriberTypeEnum.HomeownerBuildingOrRenovating,
        label: 'Homeowner - building or renovating',
    },
    {
        value: SubscriberTypeEnum.HomeownerDesignInspiration,
        label: 'Homeowner - here for design inspiration',
    },
    { value: SubscriberTypeEnum.Architect, label: 'Architect' },
    { value: SubscriberTypeEnum.InteriorDesigner, label: 'Interior designer' },
    {
        value: SubscriberTypeEnum.ConstructionOrOtherDesignProfessional,
        label: 'Construction or other design professional',
    },
    {
        value: SubscriberTypeEnum.ProductBrandOrSupplier,
        label: 'Product brand or supplier',
    },
];

/**
 * Whether a submitted value is one the schema will accept.
 *
 * The select is the only way to choose one, so this guards the form payload
 * rather than the reader — a stale value from a restored draft would otherwise
 * fail GraphQL validation and take the whole subscribe with it.
 */
export const isSubscriberType = (
    value: string | null,
): value is SubscriberTypeEnum =>
    SUBSCRIBER_TYPE_OPTIONS.some((option) => option.value === value);
